import { OcapiService } from '../ocapi/ocapi.service';
import { Md5 } from 'ts-md5/dist/md5';
import { LanguageService } from '../language/language.service';
import { DigitalData } from './digital-data';
import { AnalyticsOrder } from './analytics-order';
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(ocapiService, languageService) {
        this.ocapiService = ocapiService;
        this.languageService = languageService;
        this.udlObjectName = 'digitalData';
        window.udlObjectName = this.udlObjectName;
    }
    AnalyticsService.prototype.onHomePageWithProducts = function (omapiIds) {
        window[this.udlObjectName] = DigitalData.createForHomePage(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), omapiIds);
        this.track('page_loaded');
        this.track('user_data_loaded');
        this.track('products_loaded');
    };
    AnalyticsService.prototype.onDetailPage = function (omapiIds) {
        window[this.udlObjectName] = DigitalData.createForDetailPage(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), omapiIds);
        this.track('page_loaded');
        this.track('user_data_loaded');
        this.track('products_loaded');
    };
    AnalyticsService.prototype.onReadyToOrder = function (order) {
        window[this.udlObjectName] = DigitalData.createForOrderModal(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice));
        this.track('event_occurred');
    };
    AnalyticsService.prototype.onProductOrdered = function (order) {
        window[this.udlObjectName] = DigitalData.createForPinEntered(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice));
        this.track('event_occurred');
    };
    AnalyticsService.prototype.onOrderSucces = function (order) {
        window[this.udlObjectName] = DigitalData.createForOrderSuccess(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice));
        this.track('page_loaded');
        this.track('user_data_loaded');
        this.track('products_loaded');
    };
    AnalyticsService.prototype.onVoucherCodeEntered = function () {
        window[this.udlObjectName] = DigitalData.createForVoucherEntered(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString());
        this.track('event_occurred');
    };
    AnalyticsService.prototype.onVoucherCodeResolved = function (omapiIds) {
        window[this.udlObjectName] = DigitalData.createForVoucherResolved(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), omapiIds);
        this.track('event_occurred');
    };
    AnalyticsService.prototype.onVoucherCodeFailed = function () {
        window[this.udlObjectName] = DigitalData.createVoucherCodeFailed(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString());
        this.track('event_occurred');
    };
    AnalyticsService.prototype.onVoucherCodeSuccess = function (omapiId) {
        window[this.udlObjectName] = DigitalData.createVoucherCodeSuccess(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), omapiId);
        this.track('event_occurred');
    };
    AnalyticsService.prototype.track = function (trackName) {
        try {
            window._satellite.track(trackName);
        }
        catch (e) {
            console.log('Error finding satellite track file for file[' + trackName + ']' + e);
        }
    };
    return AnalyticsService;
}());
export { AnalyticsService };
